import {Link, useNavigate} from "react-router-dom";
import commonStyles from "../commonStyles";
import GuidaOverlay from "./GuidaOverlay";
import React, {useEffect} from "react";
import AddFriend from "../Images/AddFriend_light.png"
import Calculate from "../Images/Calculate_light.png"
import Friends from "../Images/Friends_light.png"

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}

function MainCard(props) {

    let navigate = useNavigate();

    useEffect(() => {
        props.downloadSession()
        if(readCookie("firstVisitMain") == null) {
            props.toggleOverlay(!props.showOverlay)
            createCookie("firstVisitMain", false, 30)
        } else {
            createCookie("firstVisitMain", false, 30)
        }
    }, [])

    return(
        <>
            <GuidaOverlay
                isShown = {props.showOverlay}
                images = {[{img: AddFriend, id: 0}, {img: Calculate, id: 1}, {img: Friends, id: 2}]}
                toggleOverlay = { props.toggleOverlay }
            />


            <div className="center">
                <div className="card text-center shadow-lg p-3 mt-5 bg-body rounded" style={ commonStyles.card }>
                    <div className="card-body px-4">
                        <h2 className="card-title mb-4" style={commonStyles.cardTitle}>{ props.title }</h2>
                        {props.flag && <br/>}
                        <div className="d-grid gap-2 pt-2 pb-3">
                            <button onClick={ () => navigate(props.btn1To) } className={"coolbtn"} style={ commonStyles.btn }>{ props.btn1 }</button>
                            <button onClick={ () => props.onCalcola(props.flag) } className={"coolbtn " + props.errorCalcola} style={ commonStyles.btn }>{ props.btn2 }</button>
                        </div>

                        <Link to={"FriendList"}><span className={"badge " + props.errorBadge + " mt-4"}><div className={"span-hover"}>Friends: {props.persone.length}</div></span></Link>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MainCard